import type { ReactNode } from "react";

import { createContext, useContext } from "react";

/** The page's own title, for an action in its header that needs to name it. */
export const PageTitleContext = createContext<string | undefined>(undefined);

/**
 * Actions a section gives every page under it, drawn after the page's own
 * buttons: the reports section's Export.
 */
export const PageHeaderActionsContext = createContext<ReactNode>(null);

export const usePageTitle = () => useContext(PageTitleContext);
